import { FC } from 'react';

import { RentalPeriod } from '~/entities/RentalPeriod/RentalPeriod';

import { FreeParkingPlacesList } from '~/widgets/FreeParking/FreeParkingPlacesList/FreeParkingPlacesList';
import {
  cvaFreeParking,
  cvaFreeParkingBox,
  cvaFreeParkingCols,
  cvaFreeParkingIcon,
  cvaFreeParkingInner,
  cvaFreeParkingText,
  cvaFreeParkingTitle,
} from './FreeParkingStyles';
import CheckIcon from '/public/icons/white-checker.svg?react';
import AlertIcon from '/public/icons/alert.svg?react';
import { Parking } from '~/shared/API/response-types/parkings.types';

interface Props {
  // close: (str: 'none') => void;
  openPayment: (id: string | number) => void;
  id: string | number;
  parking: Parking | undefined;
  openStartDate: (isOpen: boolean) => void;
  isScrollingHandler: (isScroll: boolean) => void;
  openDescription: boolean;
}

export const FreeParkingContent: FC<Props> = ({
  openDescription,
  openPayment,
  parking,
  openStartDate,
}) => {
  return (
    <div className={cvaFreeParking()}>
      <div className={cvaFreeParkingInner({})}>
        {!parking ? null : openDescription ? (
          <>
            <div className={cvaFreeParkingBox()}>
              {parking?.description && (
                <div
                  className={cvaFreeParkingText()}
                  dangerouslySetInnerHTML={{
                    __html: parking.description,
                  }}></div>
              )}

              <p
                className={cvaFreeParkingTitle()}
                dangerouslySetInnerHTML={{
                  __html: 'Часы работы',
                }}></p>
              <p className={cvaFreeParkingText()}>
                {parking?.is_around_the_clock ? 'Круглосуточно' : '09:00–23:00'}
              </p>
              {parking?.total_spaces ? (
                <>
                  <p
                    className={cvaFreeParkingTitle()}
                    dangerouslySetInnerHTML={{
                      __html: 'Количество мест',
                    }}></p>
                  <p className={cvaFreeParkingText()}>
                    {parking?.total_spaces}
                  </p>
                </>
              ) : null}
            </div>
            {parking?.price_text && (
              <div className={cvaFreeParkingBox()}>
                <p
                  className={cvaFreeParkingTitle()}
                  dangerouslySetInnerHTML={{
                    __html: 'Цена',
                  }}></p>
                <p
                  className={cvaFreeParkingText()}
                  dangerouslySetInnerHTML={{
                    __html: parking.price_text,
                  }}></p>
              </div>
            )}
            {parking?.tags?.length ? (
              <div className={cvaFreeParkingBox()}>
                <p
                  className={cvaFreeParkingTitle()}
                  dangerouslySetInnerHTML={{
                    __html: 'Удобства и безопасность',
                  }}></p>

                <div className={cvaFreeParkingCols()}>
                  {parking.tags.map((tag, idx) => (
                    <p key={idx} className={cvaFreeParkingText()}>
                      <CheckIcon className={cvaFreeParkingIcon()} />
                      {tag?.name}
                    </p>
                  ))}
                </div>
              </div>
            ) : null}
            {parking?.max_height && (
              <div className={cvaFreeParkingBox()}>
                <p
                  className={cvaFreeParkingTitle()}
                  dangerouslySetInnerHTML={{
                    __html: 'Ограничения',
                  }}></p>
                <p className={cvaFreeParkingText()}>
                  <AlertIcon className={cvaFreeParkingIcon()} />{' '}
                  <span>
                    <span>Высота {parking?.max_height} м</span>
                  </span>
                </p>
              </div>
            )}
          </>
        ) : (
          <div className={cvaFreeParkingBox()}>
            <RentalPeriod openStartDate={openStartDate} />
            <FreeParkingPlacesList
              id={id}
              openPayment={openPayment}
              isScrolling={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};
